export default __webpack_public_path__ + "static/media/MHpage-empty-logged-in.0a2436d6.png";